module.exports = __webpack_public_path__ + "img/Feature.b300fd57.png";